/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Style = styled.div`
  height: 12px;
  background: #F4F4F4;
  border-radius: 100px;
  position: relative;
  display: flex;
  background: #F4F4F4;
  overflow: hidden;

  &.lg {
    height: 16px;
  }
  
  .bar {
    border-radius: 100px;
    background: linear-gradient(to right,
      #CF1322 0%, #FA8C16 33%, #FADB14 66%, #73D13D 100%);
  }
`;

const defaultColors = {
  '#73D13D': 0,
  '#FADB14': 33,
  '#FA8C16': 66,
  '#CF1322': 100,
};

const getGradient = (percentage, colors) => {
  const dif = 100 / percentage;

  const values = Object.entries(colors).map(([k, v]) => {
    const perc = dif * v;
    return `${k} ${perc}%`;
  });

  return `linear-gradient(to right, ${values.join(',')})`;
};

const ProgressBar = ({
  percentage,
  colors = defaultColors,
  color,
  withTooltip = false,
  className,
}) => {
  const [gradient, setGradient] = useState();

  useEffect(() => {
    setGradient(getGradient(percentage, colors));
  }, [percentage]);

  return (
    <Style className={className}>
      {percentage !== 0 ? withTooltip ? (
        <Tooltip title={`${Math.round(percentage)}%`}>
          <div
            style={{
              background: color || gradient,
              width: `${percentage || 0}%`
            }}
            className={formatClassname(['bar'])}
          />
        </Tooltip>
      ) : (
        <div
          style={{
            background: color || gradient,
            width: `${percentage || 0}%`
          }}
          className={formatClassname(['bar'])}
        />
      ) : null}
    </Style>
  );
}

export default ProgressBar;
